import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUser, isAuthenticated } from '@/lib/auth';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Redirects unauthenticated users to /login, preserving the intended
 * destination so they can be sent there after a successful login.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }

  // Pending-password fence: a must-change account can reach only /set-password.
  if (getUser()?.mustChangePassword && location.pathname !== '/set-password') {
    return <Navigate to="/set-password" replace />;
  }

  return <>{children}</>;
}
